import React, { useMemo } from 'react';
import OverlayTitle from 'SharedComponents/OverlayTitle';
import { ShopToClubBadge } from 'SharedComponents/styled/ShopToClubBadge';
import { useShopToClubOverlayConfig } from 'Hooks/useShopToClubOverlayConfig';
import useTranslate from 'Hooks/useTranslate';
import { useConfig } from 'AppShell/hooks';

const ShopToClubHeaderWrapper: React.FunctionComponent<{}> = () => {
    const { t } = useTranslate();
    const { countryCode } = useConfig();
    const { getS2cBannerFontFromCountry } = useShopToClubOverlayConfig();

    const country = useMemo(() => {
        const [first, last] = countryCode.split('-');

        if (last) {
            return last.toLocaleLowerCase();
        }
        return first.toLocaleLowerCase();
    }, [countryCode]);

    const { mobileFontSize, desktopFontSize } = getS2cBannerFontFromCountry(country);

    return (
        <>
            <OverlayTitle headlineText="" />
            <ShopToClubBadge mobileFontSize={mobileFontSize} desktopFontSize={desktopFontSize}>
                {t('SignupAndLogin_badge')}
            </ShopToClubBadge>
        </>
    );
};

export default ShopToClubHeaderWrapper;
